import { Component, OnInit } from '@angular/core';
declare var $, unescape, escape: any;

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    checkCookie_eu();
    var currentYear = (new Date()).getFullYear();
    $("#footer_year").html(currentYear);
    function checkCookie_eu() {

      var consent = getCookie_eu("cookies_consent");

      if (consent == null || consent == "" || consent == undefined) {
        // show notification bar
        $('#cookie_directive_container').show();
      }

    }

    function setCookie_eu(c_name, value, exdays) {

      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
      document.cookie = c_name + "=" + c_value + "; path=/";

      $('#cookie_directive_container').hide();
    }


    function getCookie_eu(c_name) {
      var i, x, y, ARRcookies = document.cookie.split(";");
      for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
          return unescape(y);
        }
      }
    }


  }

  close_cookie() {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + 30);
    var c_value = escape(1) + ((30 == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = "cookies_consent =" + c_value + "; path=/";

    $('#cookie_directive_container').hide();
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/privacy-policy/privacy-policy.component.ts